/**
 * Bygglovstyper – 30+ underrubriker planerade, seeded med de mest sökta.
 */
export const bygglovRules = [
  {
    slug: "friggebod",
    title: "Friggebod – 15 m² utan bygglov",
    h1: "Friggebod – regler, mått och exempel",
    metaDescription: "Friggebod max 15 m² byggnadsarea, 3 m nockhöjd – helt bygglovsfri. Alla villkor och skillnaden mot attefallshus.",
    keywords: "friggebod, friggebod utan bygglov, 15 kvm friggebod",
    intro: "En friggebod på max 15 m² byggnadsarea och 3 m nockhöjd är helt bygglovsfri och kräver inte ens anmälan – men strandskydd och tomtgräns-avstånd gäller fortfarande.",
    verified_source: { sfs: "2010:900", chapter: "9", paragraph: "4" },
    measurements: [
      { label: "Max byggnadsarea", value: "15 m² (totalt per fastighet)" },
      { label: "Max nockhöjd", value: "3 m från medelmarknivå" },
      { label: "Avstånd tomtgräns", value: "≥ 4,5 m (utan grannmedgivande)" },
      { label: "Anmälan", value: "Krävs INTE (skiljer från attefall)" },
    ],
    examples: [
      { type: "Villa", title: "Klassisk friggebod 12 m²", text: "Redskapsbod på gården – bygg direkt, ingen anmälan behövs." },
      { type: "Villa", title: "Två friggebodar", text: "OK om totala arean är max 15 m² (t.ex. 8+7)." },
    ],
    mistakes: [
      "Att räkna friggebod och attefallshus som samma sak – attefall kräver anmälan, friggebod inte.",
      "Att placera friggebod närmare tomtgräns än 4,5 m utan grannmedgivande.",
      "Att glömma strandskydd inom 100 m från vatten.",
    ],
    municipality_variations: "Vissa detaljplaner har utökad lovplikt även för friggebodar – kolla din specifika plan.",
    faq: [
      { q: "Får jag ha friggebod OCH attefallshus?", a: "Ja – 15 m² friggebod + 30 m² attefallshus per fastighet är tillåtet." },
      { q: "Krävs bygglov för friggebod vid strand?", a: "Nej, men strandskyddsdispens kan behövas om inom 100 m från vatten." },
    ],
    related: ["attefall/attefallshus-regler", "bygglov/altan", "pbl/9-kap-bygglov-rivningslov-marklov"],
    updated: "2026-07-04",
  },
  {
    slug: "uterum",
    title: "Bygglov för uterum",
    h1: "Bygglov för uterum – regler och undantag",
    metaDescription: "Uterum: bygglov krävs för inglasning över 15 m². Attefallstillbyggnad räddar dig upp till 15 m² BTA. Alla mått.",
    keywords: "bygglov uterum, inglasat uterum, uterum attefall",
    intro: "Inglasade uterum räknas som tillbyggnad och kräver bygglov över 15 m². Under 15 m² BTA räcker anmälan via attefallstillbyggnad.",
    measurements: [
      { label: "Lovbefriad", value: "Endast oöppningsbart skärmtak, öppet på sidor" },
      { label: "Attefallstillbyggnad", value: "≤ 15 m² BTA – anmälan räcker" },
      { label: "Bygglov", value: "Över 15 m² eller vid ändring av bostadsyta" },
    ],
    examples: [
      { type: "Villa", title: "Litet uterum 12 m²", text: "Inglasat – räknas som attefallstillbyggnad, anmälan räcker." },
      { type: "Villa", title: "Stort uterum 20 m²", text: "Bygglov krävs – full prövning mot detaljplan." },
    ],
    mistakes: ["Att tro att inglasat uterum är lovfritt om det är litet – 12 m² är alltid tillbyggnad."],
    municipality_variations: "I kulturmiljö kan även små uterum kräva bygglov.",
    faq: [
      { q: "Räknas uterum som boyta?", a: "Endast om det är uppvärmt året runt och används som del av bostaden." },
    ],
    related: ["bygglov/altan", "bygglov/tillbyggnad", "attefall/attefallstillbyggnad-15m"],
    updated: "2026-07-04",
  },
  {
    slug: "varmepump",
    title: "Bygglov för värmepump",
    h1: "Bygglov för värmepump – bergvärme, luftvärmepump",
    metaDescription: "Bergvärme kräver anmälan enligt Miljöbalken (inte bygglov). Luftvärmepump är fri. Alla regler 2026.",
    keywords: "bygglov värmepump, bergvärme anmälan, luftvärmepump regler",
    intro: "Bergvärme, sjövärme och ytjordvärme kräver anmälan till kommunens miljökontor enligt Miljöbalken – inte bygglov. Luftvärmepump är oftast helt fri.",
    examples: [
      { type: "Villa", title: "Bergvärme", text: "Anmälan till kommunens miljökontor krävs 6 veckor innan borrning." },
      { type: "Villa", title: "Luftvärmepump på fasad", text: "Fri utomhus – ingen anmälan om ej på skyddad byggnad." },
    ],
    mistakes: [
      "Att borra bergvärmehål innan anmälan är godkänd.",
      "Att placera luftvärmepump på Q-märkt hus utan bygglov.",
    ],
    municipality_variations: "Vissa kommuner (särskilt vattenskyddsområden) har strängare regler för bergvärme.",
    faq: [
      { q: "Krävs bygglov för luftvärmepump?", a: "Nej, om det inte är kulturmiljöskyddad byggnad." },
    ],
    related: ["bbr/kap-9-energihushallning", "bygglov/solceller"],
    updated: "2026-07-04",
  },
  {
    slug: "staket",
    title: "Regler för staket",
    h1: "Staket – höjder och bygglov",
    metaDescription: "Staket upp till 1,10 m är lovfritt. Högre räknas som plank och kräver bygglov inom detaljplan.",
    keywords: "staket bygglov, staket höjd, staket tomtgräns",
    intro: "Staket under 1,10 m är helt lovfritt. Över den höjden räknas det som plank och kräver bygglov inom detaljplan.",
    measurements: [
      { label: "Lovfritt", value: "≤ 1,10 m höjd" },
      { label: "Genomsiktlighet", value: "> 50% (annars räknas det som plank)" },
      { label: "Skillnad från plank", value: "Plank är tätt, staket är luftigt" },
    ],
    examples: [
      { type: "Villa", title: "Standardstaket 100 cm", text: "Bygg direkt utan tillstånd." },
    ],
    mistakes: ["Att räkna staket och plank som samma sak – luftigheten är avgörande."],
    municipality_variations: "Vissa detaljplaner sätter lägre max-höjder mot gata.",
    faq: [
      { q: "Måste jag prata med grannen?", a: "Nej vid lovfritt staket. Men vid gemensam tomtgräns är dialog alltid smart." },
    ],
    related: ["bygglov/plank", "bygglov/altan"],
    updated: "2026-07-04",
  },
  {
    slug: "skylt",
    title: "Bygglov för skylt",
    h1: "Bygglov för skylt & reklam",
    metaDescription: "Skyltar inom detaljplan kräver oftast bygglov. Undantag för mindre skyltar upp till 1 m². Alla regler.",
    keywords: "bygglov skylt, reklamskylt, skylt storlek",
    intro: "Skyltar och reklamskyltar inom detaljplanelagt område kräver bygglov om de är över 1 m² eller kan påverka stads-/landskapsbild.",
    measurements: [
      { label: "Liten skylt lovfri", value: "≤ 1 m² inom detaljplan" },
      { label: "Bygglov", value: "> 1 m² eller påverkar stadsbild" },
    ],
    examples: [{ type: "Verksamhet", title: "Butik-fasadskylt 5 m²", text: "Bygglov krävs – prövas mot detaljplan och kulturmiljö." }],
    mistakes: ["Att sätta upp reklamskylt utan lov – kan leda till byggsanktion."],
    municipality_variations: "Kulturmiljö och innerstad är oftast strängare.",
    faq: [{ q: "Krävs bygglov för väl-syntlig LED-skylt?", a: "Ja alltid – prövas även mot ljusreklampraxis." }],
    related: ["bygglov/fasadandring"],
    updated: "2026-07-04",
  },
  {
    slug: "handlaggningstid",
    title: "Handläggningstid bygglov – 10 veckor",
    h1: "Bygglov handläggningstid – 10-veckorsregeln",
    metaDescription: "PBL 9:27 – kommunen har max 10 veckor från komplett ansökan. Kan förlängas 10 v. Så räknas tiden.",
    keywords: "bygglov handläggningstid, 10 veckor, reducerad avgift",
    intro: "Kommunen ska besluta i bygglovsärende inom 10 veckor från att ansökan är komplett. Vid förlängning måste beslut om det tas inom 10 v – och avgiften reduceras 20% per påbörjad vecka över 10.",
    verified_source: { sfs: "2010:900", chapter: "9", paragraph: "27" },
    examples: [
      { type: "Villa", title: "Standard-bygglov villa", text: "Komplett ansökan 1 mars → beslut senast 10 maj." },
      { type: "Kommun", title: "Vid komplex sak", text: "Kommunen kan förlänga med max 10 v (totalt 20 v) om skäl finns." },
    ],
    mistakes: ["Att räkna 10-veckor från när du skickar in – räknas från KOMPLETT ansökan efter ev. komplettering."],
    municipality_variations: "Reducerad avgift enligt PBL 12:8 gäller nationellt.",
    faq: [
      { q: "Vad menas med 'komplett ansökan'?", a: "När kommunen bedömer att alla ritningar, kontrollplaner och uppgifter är korrekta och tillräckliga." },
      { q: "Får jag pengar tillbaka?", a: "Ja – 20% avgiftsreduktion per påbörjad vecka utöver 10 v." },
    ],
    related: ["bygglov/bygglovsavgift", "pbl/9-kap-bygglov-rivningslov-marklov"],
    updated: "2026-07-04",
  },
  {
    slug: "olovligt-bygge",
    title: "Olovligt bygge – konsekvenser",
    h1: "Olovligt bygge – byggsanktion och preskription",
    metaDescription: "Byggsanktionsavgift, rivningsföreläggande och 10-års preskription. Så hanteras olovligt byggande enligt PBL 11 kap.",
    keywords: "olovligt bygge, byggsanktionsavgift, preskription 10 år",
    intro: "Att bygga utan lov eller anmälan är sanktionsbelagt. Preskriptionstiden är 10 år – efter det kan kommunen inte längre kräva rivning, men lov krävs fortfarande för framtida ändringar.",
    verified_source: { sfs: "2010:900", chapter: "11", paragraph: "51" },
    measurements: [
      { label: "Byggsanktionsavgift attefall", value: "~50 000 – 200 000 kr" },
      { label: "Preskriptionstid", value: "10 år från slutförande" },
      { label: "Möjlig avgiftsnedsättning", value: "Max 50% (särskilda skäl)" },
    ],
    examples: [
      { type: "Villa", title: "Byggt attefall utan anmälan", text: "Sanktion beräknas som 25% × prisbasbelopp + 0,5% × produktionskostnad per m²." },
    ],
    mistakes: ["Att söka lov i efterhand och tro att sanktionen försvinner – avgiften kvarstår."],
    municipality_variations: "Byggnadsnämnden kan sätta ned avgiften vid särskilda skäl.",
    faq: [
      { q: "Kan jag legalisera bygge?", a: "Ja, genom bygglov i efterhand. Sanktion tas dock ut." },
      { q: "Räknas 10-årsregeln från byggstart eller slutfört?", a: "Från slutfört bygge." },
    ],
    related: ["pbl/6-kap-tillsyn", "bygglov/rivningslov"],
    updated: "2026-07-04",
  },
  {
    slug: "grannmedgivande",
    title: "Grannmedgivande – så skriver du",
    h1: "Grannmedgivande vid attefall – så gör du",
    metaDescription: "Skriftligt grannmedgivande krävs för att placera attefall närmare tomtgräns än 4,5 m. Mall och praktiska tips.",
    keywords: "grannmedgivande, attefall tomtgräns, skriftligt medgivande",
    intro: "För att placera attefall/friggebod närmare tomtgräns än 4,5 m behöver du skriftligt medgivande från alla berörda grannar. Muntligt räcker inte.",
    examples: [
      { type: "Villa", title: "Standardmall", text: "Signerat papper med grannens namn, fastighetsbeteckning, situationsplan där placering framgår, och underskrift." },
    ],
    mistakes: [
      "Att förlita sig på muntligt medgivande – kommunen accepterar det inte.",
      "Att glömma att kommunen räknas som granne mot gata/park.",
    ],
    municipality_variations: "Vissa kommuner kräver formellt yttrande utöver signatur på ritning.",
    faq: [
      { q: "Vad händer om grannen säger nej?", a: "Du kan söka bygglov istället – kommunen prövar då åtgärden trots avvikelse." },
    ],
    related: ["attefall/attefall-avstand-tomtgrans", "attefall/attefallshus-regler"],
    updated: "2026-07-04",
  },
  {
    slug: "overklaga-bygglov",
    title: "Överklaga bygglov",
    h1: "Överklaga bygglovsbeslut – så gör du",
    metaDescription: "Överklaga bygglov till länsstyrelsen inom 3 v från kungörelse. Vem får överklaga, hur du skriver.",
    keywords: "överklaga bygglov, länsstyrelsen bygglov, sakägare",
    intro: "Bygglovsbeslut kan överklagas av sakägare (grannar, boende, hyresgäster) inom 3 veckor från kungörelse. Överklagan skickas till länsstyrelsen via kommunen.",
    examples: [
      { type: "Villa", title: "Granne överklagar", text: "Skriv överklagande med grunder + bevis inom 3 v från kungörelse (Post- och Inrikes Tidningar)." },
    ],
    mistakes: ["Att missa 3-veckorsfristen – beslutet vinner då laga kraft."],
    municipality_variations: "Kungörelse-datum kan skilja mellan kommuner – kolla lokalt.",
    faq: [
      { q: "Vem räknas som sakägare?", a: "Grannar med rågräns, boende inom påverkan, hyresgäster. Bedöms från fall till fall." },
    ],
    related: ["pbl/9-kap-bygglov-rivningslov-marklov", "pbl/6-kap-tillsyn"],
    updated: "2026-07-04",
  },
  {
    slug: "bygglovsavgift",
    title: "Bygglovsavgift – kostnader 2026",
    h1: "Bygglovsavgift – vad kostar bygglov?",
    metaDescription: "Kostnader för bygglov 2026: attefall 5-15 000, tillbyggnad 15-30 000, nybyggnation 30-100 000. Så beräknas avgiften.",
    keywords: "bygglovsavgift, kostnad bygglov, taxa PBL",
    intro: "Bygglovsavgift bestäms av respektive kommun via en taxa som baseras på PBL 12 kap. Storleken beror på ärendetyp, area och komplexitet.",
    measurements: [
      { label: "Anmälan attefall", value: "3 000 – 10 000 kr" },
      { label: "Bygglov tillbyggnad villa", value: "10 000 – 25 000 kr" },
      { label: "Bygglov nybyggnad villa", value: "25 000 – 60 000 kr" },
      { label: "Rivningslov", value: "5 000 – 15 000 kr" },
    ],
    examples: [
      { type: "Villa", title: "Stockholm tillbyggnad 30 m²", text: "Cirka 18 000 kr enligt Stockholms taxa 2026." },
    ],
    mistakes: ["Att inte begära offert innan – avgiften varierar 3-4x mellan kommuner."],
    municipality_variations: "Skillnader på 100-300% mellan kommuner för samma ärendetyp.",
    faq: [
      { q: "Får jag rabatt vid försenad handläggning?", a: "Ja – 20% per påbörjad vecka över 10 veckors handläggningstid." },
    ],
    related: ["bygglov/handlaggningstid", "pbl/9-kap-bygglov-rivningslov-marklov"],
    updated: "2026-07-04",
  },
  {
    slug: "altan",
    title: "Bygglov för altan",
    h1: "Bygglov för altan – regler, mått och exempel",
    metaDescription:
      "Behöver du bygglov för altan? 1,8 m-regeln, undantag för låga altaner, uterum och skärmtak. Guide 2026.",
    keywords: "bygglov altan, altan utan bygglov, 1,8 meter altan",
    intro:
      "Låg altan (under 1,8 m från marken) närmare huset än 3,6 m är oftast lovbefriad. Högre altaner eller inglasningar kräver bygglov.",
    measurements: [
      { label: "Lovbefriad höjd", value: "≤ 1,8 m från marken" },
      { label: "Max avstånd från huvudbyggnad", value: "3,6 m" },
      { label: "Avstånd till tomtgräns", value: "4,5 m (eller grannmedgivande)" },
      { label: "Inglasad altan", value: "Räknas som tillbyggnad – bygglov krävs" },
    ],
    examples: [
      { type: "Villa", title: "Låg altan 30 m²", text: "0,3 m från marken, i anslutning till villan – ingen bygglov behövs." },
      { type: "Villa", title: "Upphöjd altan 50 cm", text: "Under 1,8 m men över 30 cm – kontrollera detaljplan då vissa kommuner kräver bygglov." },
      { type: "Attefall", title: "Inglasat uterum 12 m²", text: "Inglasat = tillbyggnad, alltid bygglov OM ej attefallstillbyggnad (max 15 m²)." },
    ],
    mistakes: [
      "Att bygga inglasat uterum utan lov – räknas som tillbyggnad.",
      "Att glömma tomtgränsavståndet 4,5 m även för lovbefriade altaner.",
    ],
    municipality_variations:
      "Vissa kommuner kräver bygglov för altaner även under 1,8 m i tätbebyggd innerstad. Kolla detaljplan.",
    faq: [
      { q: "Behöver jag bygglov för trädäck?", a: "Om det är under 1,8 m från mark och närmare hus än 3,6 m – nej, oftast lovbefriad." },
      { q: "Får jag bygga altantak?", a: "Skärmtak upp till 15 m² är lovbefriat om det uppfyller vissa villkor (max 3 m från huset)." },
    ],
    howto: {
      name: "Så bygger du altan lagligt",
      steps: [
        { name: "1. Mät höjden", text: "Från lägsta marknivå till altandäckets ovansida. Måste vara under 1,8 m för lovbefrielse." },
        { name: "2. Kolla detaljplan", text: "Vissa detaljplaner har utökad lovplikt för altaner." },
        { name: "3. Om lovpliktig – sök bygglov", text: "Ritningar + situationsplan + kontrollplan." },
      ],
    },
    related: ["bygglov/tillbyggnad", "bygglov/plank", "attefall/attefallshus-regler"],
    updated: "2026-07-04",
  },
  {
    slug: "pool",
    title: "Bygglov för pool",
    h1: "Bygglov för pool – vad gäller?",
    metaDescription:
      "Pool på tomten: när krävs bygglov, marklov eller anmälan? Djup, staket, avstånd och kommunala krav.",
    keywords: "bygglov pool, pool anmälan, poolstaket",
    intro:
      "Pooler i marknivå kräver oftast inte bygglov – men marklov kan behövas för schaktning. Höga pooler eller inhägnader kan kräva bygglov.",
    measurements: [
      { label: "Marklov för schakt", value: "Krävs om > 0,5 m schaktning inom detaljplan" },
      { label: "Staket runt pool", value: "Krav enligt Boverket: minst 90 cm högt" },
      { label: "Skärmtak/poolhus", value: "Kan vara attefallsbefriat om ≤ 30 m²" },
    ],
    examples: [
      { type: "Villa", title: "Nedgrävd pool", text: "Marklov för schaktning + eventuellt bygglov för poolhus. Pool i sig är oftast lovfri." },
      { type: "Villa", title: "Ovanmarkspool", text: "Sätts på marken – ingen marklov behövs. Men staket krävs enligt Boverket." },
    ],
    mistakes: [
      "Att glömma barnsäkerhetsstaket – lagkrav för att förhindra drunkning.",
      "Att inte söka marklov vid större schaktning inom detaljplan.",
    ],
    municipality_variations:
      "Vissa kommuner kräver bygglov för pooler över viss storlek eller djup. Kolla lokalt.",
    faq: [
      { q: "Behöver jag staket runt pool?", a: "Ja, minst 90 cm högt runt hela pool. Ordningslag & Boverkets råd." },
      { q: "Får jag ha pool på strandtomt?", a: "Kräver oftast strandskyddsdispens – schaktning påverkar strandmiljön." },
    ],
    related: ["bygglov/plank", "bbr/kap-5-brandskydd", "strandskydd/100-metersregeln"],
    updated: "2026-07-04",
  },
  {
    slug: "garage",
    title: "Bygglov för garage",
    h1: "Bygglov för garage – regler och kostnader",
    metaDescription:
      "Bygga garage: bygglov, mått, avstånd till tomtgräns och skillnad attefallsgarage vs bygglovsgarage.",
    keywords: "bygglov garage, garage attefall, garage tomtgräns",
    intro:
      "Ett garage upp till 30 m² kan byggas som attefallshus (utan bygglov men med anmälan). Större garage kräver bygglov.",
    measurements: [
      { label: "Attefallsgarage", value: "Max 30 m² – anmälan räcker" },
      { label: "Bygglovsgarage", value: "Över 30 m² eller inom kulturmiljö – bygglov krävs" },
      { label: "Höjd", value: "Max 4 m för attefall" },
    ],
    examples: [
      { type: "Villa", title: "Enkelgarage 25 m²", text: "Attefall räcker – anmälan + startbesked." },
      { type: "Villa", title: "Dubbelgarage 45 m²", text: "Bygglov krävs – kräver planhantering + kontrollansvarig." },
    ],
    mistakes: [
      "Att missa brandkrav mellan sammanbyggt garage och bostad (EI30-vägg + branddörr).",
      "Att bygga innan startbesked.",
    ],
    municipality_variations:
      "I detaljplanelagt område med utökad lovplikt kan även attefallsgarage kräva bygglov.",
    faq: [
      { q: "Får jag ha carport och garage samtidigt?", a: "Ja, men totala byggnadsarean för alla attefall får inte överstiga 30 m² per fastighet." },
      { q: "Måste garaget vara isolerat?", a: "Nej, oisolerad garage har lägre BBR-krav och räknas ofta som komplementbyggnad." },
    ],
    related: ["bygglov/carport", "attefall/attefallshus-regler", "bbr/kap-5-brandskydd"],
    updated: "2026-07-04",
  },
  {
    slug: "carport",
    title: "Bygglov för carport",
    h1: "Bygglov för carport – enkla regler",
    metaDescription:
      "Carport: bygglov, mått och attefallsregler. Så bygger du en carport lagligt.",
    keywords: "bygglov carport, carport attefall",
    intro:
      "Carport upp till 30 m² räknas som komplementbyggnad och omfattas av attefallsreglerna.",
    measurements: [
      { label: "Max byggnadsarea attefall", value: "30 m²" },
      { label: "Max höjd", value: "4 m nockhöjd" },
      { label: "Placering", value: "≥ 4,5 m från tomtgräns" },
    ],
    examples: [
      { type: "Villa", title: "Fristående carport 20 m²", text: "Anmälan + startbesked räcker." },
    ],
    mistakes: [
      "Att bygga carport tätt intill huset utan brandskydd.",
    ],
    municipality_variations:
      "Vissa kommuner räknar carport som del av huvudbyggnaden om den är sammanbyggd – då gäller bygglov.",
    faq: [
      { q: "Är carport och garage samma sak?", a: "Nej, carport är öppen minst på två sidor. Ett garage är slutet." },
    ],
    related: ["bygglov/garage", "attefall/attefallshus-regler"],
    updated: "2026-07-04",
  },
  {
    slug: "plank",
    title: "Bygglov för plank",
    h1: "Bygglov för plank – höjder och regler",
    metaDescription:
      "Plank, staket och mur: när krävs bygglov? 1,10 m-regeln och undantag.",
    keywords: "bygglov plank, plank tomtgräns, mur bygglov",
    intro:
      "Staket under 1,10 m är oftast lovfritt. Plank (tätt över 1,10 m) kräver bygglov inom detaljplan.",
    measurements: [
      { label: "Lovfritt staket", value: "≤ 1,10 m höjd" },
      { label: "Plank inom detaljplan", value: "Bygglov krävs" },
      { label: "Skyddsmur/stödmur", value: "Kan kräva marklov" },
    ],
    examples: [
      { type: "Villa", title: "Låg staket 90 cm", text: "Lovbefriad – inget behöver anmälas." },
      { type: "Villa", title: "Plank 1,8 m", text: "Bygglov krävs – prövning mot detaljplan och grannintressen." },
    ],
    mistakes: [
      "Att räkna staket och plank som samma sak – luftighet avgör.",
      "Att inte söka bygglov för höga stödmurar.",
    ],
    municipality_variations:
      "Höjdgränsen kan variera lokalt – 1,10 m är standard men vissa kommuner tillåter upp till 1,20 m.",
    faq: [
      { q: "Vad är skillnaden staket och plank?", a: "Staket är luftigt (över 50 % genomsiktligt). Plank är tätt. Höjdgränsen är samma men bygglovsbedömningen skiljer." },
    ],
    related: ["bygglov/altan", "pbl/9-kap-bygglov-rivningslov-marklov"],
    updated: "2026-07-04",
  },
  {
    slug: "solceller",
    title: "Bygglov för solceller",
    h1: "Bygglov för solceller – oftast bygglovsbefriat 2026",
    metaDescription:
      "Solceller på tak: nya reglerna 2026 gör montaget bygglovsbefriat om det följer takets lutning. Undantag för kulturmiljö.",
    keywords: "bygglov solceller, solpaneler tak, solceller anmälan",
    intro:
      "Sedan 2022 är solceller på befintlig byggnad bygglovsbefriade om de följer takets form. Undantag: kulturmiljö och detaljplan med utökad lovplikt.",
    excerpt: {
      text: "En åtgärd för att på en byggnad montera solcellspaneler och solfångare som följer byggnadens form kräver inte bygglov.",
      source: "PBL 9 kap. 3d §",
    },
    examples: [
      { type: "Villa", title: "Panel på befintligt tak", text: "Följer takets form och lutning – lovbefriat även inom detaljplan (om ej utökad lovplikt)." },
      { type: "Villa", title: "Fristående solcellsställning", text: "På mark – räknas som byggnadsverk och kräver bygglov." },
    ],
    mistakes: [
      "Att bygga fristående solcellsstruktur utan bygglov.",
      "Att sätta solceller i kulturmiljö utan tillstånd.",
    ],
    municipality_variations:
      "Riksintresse för kulturmiljö + värdefull bebyggelse (Q- eller K-märkt) – kräver bygglov.",
    faq: [
      { q: "Krävs anmälan?", a: "Nej, bara om solcellsanläggningen påverkar bärande konstruktion eller brandskydd." },
      { q: "Får jag solceller på Q-märkt hus?", a: "Kräver bygglov – och kan nekas om det påverkar kulturvärdet." },
    ],
    related: ["bbr/kap-9-energihushallning", "pbl/9-kap-bygglov-rivningslov-marklov"],
    updated: "2026-07-04",
  },
  {
    slug: "tillbyggnad",
    title: "Bygglov för tillbyggnad",
    h1: "Bygglov för tillbyggnad – regler och exempel",
    metaDescription:
      "Tillbyggnad kräver bygglov över 15 m². Attefallstillbyggnad, förhöjning och utökning – alla regler samlade.",
    keywords: "bygglov tillbyggnad, tillbyggnad regler, förhöjning",
    intro:
      "Tillbyggnad över 15 m² kräver bygglov. Under 15 m² kan attefallsreglerna gälla – med anmälan istället.",
    examples: [
      { type: "Villa", title: "Utbyggnad 20 m²", text: "Bygglov krävs. Prövas mot detaljplan (byggnadsarea, byggrätt) och grannintressen." },
      { type: "Attefall", title: "Attefallstillbyggnad 15 m²", text: "Anmälan räcker – ingen bygglov." },
    ],
    mistakes: [
      "Att räkna bostadsarea (BOA) istället för bruttoarea (BTA).",
      "Att glömma påverkan på byggrätt om detaljplan begränsar antal m².",
    ],
    municipality_variations:
      "Detaljplanen är avgörande – vissa har max 200 m² BTA, andra procentuell byggrätt (t.ex. 20 % av tomten).",
    faq: [
      { q: "Kan jag bygga på höjden?", a: "Ja, men det räknas som tillbyggnad och kräver bygglov om över 15 m² tillkommande BTA." },
    ],
    related: ["attefall/attefallstillbyggnad-15m", "bygglov/altan", "detaljplan/dp-byggnadsarea"],
    updated: "2026-07-04",
  },
  {
    slug: "fasadandring",
    title: "Bygglov för fasadändring",
    h1: "Bygglov för fasadändring – färg, material, fönster",
    metaDescription:
      "Fasadändring kräver bygglov om det ändrar byggnadens karaktär – t.ex. färgbyte i tätort eller nya fönster.",
    keywords: "bygglov fasad, fasadändring, färgbyte hus",
    intro:
      "Väsentliga fasadändringar (färg, material, fönstersättning) kräver bygglov inom detaljplan – utanför är det oftast lovfritt.",
    excerpt: {
      text: "Det krävs bygglov för att ändra en byggnads yttre utseende avsevärt genom att färga om byggnaden, byta fasadbeklädnad eller byta taktäckningsmaterial.",
      source: "PBL 9 kap. 2 § p. 3",
    },
    examples: [
      { type: "Villa", title: "Byta från gul till röd fasad", text: "Inom detaljplan – bygglov krävs. Utanför detaljplan i regel lovfritt." },
      { type: "Villa", title: "Sätta in nya fönster", text: "Nya fönster på ny plats = bygglov. Byta i befintlig öppning = ofta lovfritt." },
    ],
    mistakes: [
      "Att tro att färgbyte alltid är lovbefriat – gäller bara utanför detaljplan.",
      "Att glömma kulturmiljöskydd (Q-märkning).",
    ],
    municipality_variations:
      "I kulturmiljö och innerstad är fasadändring ofta hårt reglerad – kan även bli avslag.",
    faq: [
      { q: "Får jag byta tak?", a: "Byta samma material = lovfritt. Byta från tegel till plåt = kan kräva bygglov inom detaljplan." },
    ],
    related: ["pbl/9-kap-bygglov-rivningslov-marklov", "bygglov/tillbyggnad"],
    updated: "2026-07-04",
  },
  {
    slug: "rivningslov",
    title: "Rivningslov – när krävs det?",
    h1: "Rivningslov – regler och undantag",
    metaDescription:
      "Riva byggnad: rivningslov krävs inom detaljplan, rivningsanmälan utanför. Så söker du.",
    keywords: "rivningslov, riva hus, rivningsanmälan",
    intro:
      "Rivning av byggnad kräver rivningslov inom detaljplanelagt område. Utanför räcker rivningsanmälan.",
    examples: [
      { type: "Villa", title: "Riva gammalt garage", text: "Inom detaljplan – rivningslov krävs. Beslut inom 10 veckor." },
    ],
    mistakes: [
      "Att riva utan lov – byggsanktion och krav på återuppbyggnad kan följa.",
    ],
    municipality_variations:
      "Kulturhistoriskt värdefulla byggnader kan förbjudas rivas trots detaljplan.",
    faq: [
      { q: "Krävs lov för att riva ett Attefallshus?", a: "Nej, men anmälan om rivning krävs." },
    ],
    related: ["pbl/9-kap-bygglov-rivningslov-marklov", "bygglov/marklov"],
    updated: "2026-07-04",
  },
  {
    slug: "marklov",
    title: "Marklov – schaktning och trädfällning",
    h1: "Marklov – när krävs det?",
    metaDescription:
      "Marklov krävs för schaktning över 0,5 m inom detaljplan och för fällning av träd i vissa områden.",
    keywords: "marklov, schaktning, trädfällning",
    intro:
      "Marklov behövs vid större schaktning eller fyllning inom detaljplanelagt område – normalt över 0,5 m.",
    examples: [
      { type: "Villa", title: "Pool-schaktning", text: "1,5 m djup grop i tätort = marklov krävs." },
    ],
    mistakes: [
      "Att fylla ut tomten med jord utan marklov.",
      "Att fälla skyddade träd utan tillstånd (även när marklov ej krävs).",
    ],
    municipality_variations:
      "I vissa detaljplaner krävs marklov för alla markändringar > 0,3 m.",
    faq: [
      { q: "Krävs marklov för att fälla träd?", a: "Bara om detaljplanen skyddar träden eller om det är biotopskyddat område." },
    ],
    related: ["bygglov/rivningslov", "bygglov/pool"],
    updated: "2026-07-04",
  },
  {
    slug: "mur",
    title: "Bygglov för mur och stödmur",
    h1: "Bygglov för mur – höjd, avstånd och stödmurar",
    metaDescription: "Mur högre än 0,5 m kräver oftast bygglov. Stödmurar, prydnadsmurar och avstånd till tomtgräns. Regler 2026.",
    keywords: "bygglov mur, stödmur höjd, prydnadsmur tomtgräns",
    intro: "Murar över 0,5 m kräver som huvudregel bygglov. Stödmurar för att hålla upp mark räknas som bygglovspliktiga anläggningar och prövas ofta strängare än plank.",
    measurements: [
      { label: "Lovbefriad höjd", value: "≤ 0,5 m från marknivå" },
      { label: "Bygglov krävs", value: "Över 0,5 m eller stödmur oavsett höjd" },
      { label: "Avstånd tomtgräns", value: "≥ 4,5 m (utan grannmedgivande)" },
    ],
    examples: [
      { type: "Villa", title: "Låg trädgårdsmur 40 cm", text: "Lovfri – ingen anmälan behövs." },
      { type: "Villa", title: "Stödmur 1,2 m", text: "Bygglov krävs – lämna in ritning med konstruktion och dränering." },
    ],
    mistakes: [
      "Att bygga stödmur utan att beräkna jordtryck och dränering – kan orsaka ras.",
      "Att glömma bygglov även för låga stödmurar som håller upp mark.",
    ],
    municipality_variations: "Kustkommuner har ofta krav på estetisk anpassning för synliga murar.",
    faq: [
      { q: "Räknas gabionmur som mur?", a: "Ja – bygglov krävs om över 0,5 m." },
      { q: "Får jag bygga mur i tomtgräns?", a: "Endast med grannens skriftliga medgivande." },
    ],
    related: ["bygglov/plank", "bygglov/staket", "bygglov/marklov"],
    updated: "2026-07-04",
  },
  {
    slug: "spa-jacuzzi",
    title: "Bygglov för spabad och jacuzzi",
    h1: "Bygglov för spa och jacuzzi – utomhus och inomhus",
    metaDescription: "Fristående spabad kräver oftast inte bygglov. Nedgrävt spa räknas som pool. Regler för placering, el och avstånd 2026.",
    keywords: "bygglov spa, jacuzzi utomhus, spabad regler",
    intro: "Ett flyttbart spabad på marken kräver normalt inte bygglov. Om spat grävs ner eller integreras med altan/terrass räknas det som pool och kräver bygglov om det är permanent och över viss storlek.",
    measurements: [
      { label: "Fristående spabad", value: "Ingen lovplikt – kan flyttas" },
      { label: "Nedgrävt spa", value: "Räknas som pool – bygglov över 3 m²/50 cm djup" },
      { label: "Elinstallation", value: "Behörig elinstallatör krävs (starkström)" },
    ],
    examples: [
      { type: "Villa", title: "Portabelt spa på altan", text: "Ingen lovplikt – bara att koppla in el korrekt." },
      { type: "Villa", title: "Inbyggt spa i marken", text: "Bygglov krävs som för pool + skyddsstaket." },
    ],
    mistakes: [
      "Att glömma barnsäkerhetskrav vid nedgrävt spa (staket ≥ 90 cm, självstängande grind).",
      "Att koppla in el själv utan behörighet – livsfara.",
    ],
    municipality_variations: "Inga stora skillnader – men strandskyddet gäller alltid 100 m från vatten.",
    faq: [
      { q: "Måste jag anmäla spa till försäkringsbolaget?", a: "Ja – många hemförsäkringar kräver anmälan för att täcka vattenskador." },
    ],
    related: ["bygglov/pool", "bygglov/altan"],
    updated: "2026-07-04",
  },
  {
    slug: "laddstolpe",
    title: "Bygglov för laddstolpe (elbil)",
    h1: "Bygglov för laddstolpe hemma – regler och undantag",
    metaDescription: "Laddstolpe på egen tomt kräver oftast inte bygglov. På allmän plats eller flerbostadshus krävs bygglov. Alla regler 2026.",
    keywords: "bygglov laddstolpe, elbilsladdare hemma, laddbox regler",
    intro: "En laddstolpe/laddbox på egen tomt är normalt bygglovsfri. På allmän plats, i garage för flera lägenheter eller om laddstolpen är över 1,2 m hög kan bygglov krävas.",
    measurements: [
      { label: "Villa egen tomt", value: "Bygglovsfri – behörig elinstallatör krävs" },
      { label: "Brf/samfällighet", value: "Bygglov krävs för fasta installationer i garage" },
      { label: "Publik laddstolpe", value: "Bygglov krävs alltid" },
    ],
    examples: [
      { type: "Villa", title: "Laddbox på garagevägg", text: "Bygglovsfri, ROT-avdrag och statligt bidrag (Klimatpremie) kan sökas." },
      { type: "Brf", title: "10 laddplatser i garage", text: "Bygglov + installationsanmälan till elnätsägaren krävs." },
    ],
    mistakes: [
      "Att koppla in laddbox på befintlig 10A-uttag – kan orsaka brand.",
      "Att glömma anmäla anläggningen till elnätsägaren om säkringen behöver ökas.",
    ],
    municipality_variations: "Vissa kommuner ger extra bidrag för laddinfrastruktur i äldre områden.",
    faq: [
      { q: "Får jag bidrag för laddstolpe hemma?", a: "Ja – Klimatpremien via Naturvårdsverket täcker upp till 50 % av kostnaden." },
      { q: "Kan grannen kräva att jag flyttar min laddstolpe?", a: "Endast om den placerats närmare tomtgräns än 4,5 m utan tillstånd." },
    ],
    related: ["bygglov/solceller", "bygglov/varmepump"],
    updated: "2026-07-04",
  },
  {
    slug: "belysning-utomhus",
    title: "Bygglov för utomhusbelysning",
    h1: "Bygglov för belysning – lampor, strålkastare och ljusskyltar",
    metaDescription: "Vanlig fasadbelysning är bygglovsfri. Ljusskyltar och strålkastare mot allmän plats kräver bygglov. Regler 2026.",
    keywords: "bygglov belysning, fasadbelysning, ljusskylt bygglov",
    intro: "Vanliga utomhuslampor på fasad eller stolpe i trädgården är bygglovsfria. Ljusskyltar och kraftig fasadbelysning mot allmän plats kan kräva bygglov enligt PBL 6 kap.",
    measurements: [
      { label: "Fasadlampor villa", value: "Bygglovsfri" },
      { label: "Ljusskylt över 0,5 m²", value: "Bygglov krävs" },
      { label: "Strålkastare mot allmän plats", value: "Bygglov + ev. tillstånd Polisen" },
    ],
    examples: [
      { type: "Villa", title: "5 st fasadlampor", text: "Bygglovsfria – välj varmvit LED för minst ljusföroreningar." },
      { type: "Butik", title: "Ljusskylt 2 m²", text: "Bygglov + skyltavgift till kommunen." },
    ],
    mistakes: [
      "Att sätta upp starkt riktljus som stör grannar – kan ge klagomål även utan bygglov.",
      "Att glömma bygglov för blinkande LED-skyltar.",
    ],
    municipality_variations: "Kulturhistoriskt värdefulla områden har ofta krav på diskret belysning.",
    faq: [
      { q: "Är solcellsdrivna trädgårdslampor bygglovsfria?", a: "Ja – helt fria eftersom de saknar fast installation." },
    ],
    related: ["bygglov/skylt", "bygglov/solceller"],
    updated: "2026-07-04",
  },
  {
    slug: "tillfallig-byggnad",
    title: "Tillfälligt bygglov och säsongsbyggnader",
    h1: "Tillfälligt bygglov – bodar, tält och säsongsbyggnader",
    metaDescription: "Tidsbegränsat bygglov ges för max 10 år (kan förlängas till 15). Byggbodar, festtält och pop-up-butiker. Regler 2026.",
    keywords: "tillfälligt bygglov, tidsbegränsat bygglov, byggbod bygglov",
    intro: "Tidsbegränsat bygglov (PBL 9:33) kan ges för åtgärder som inte uppfyller alla krav i detaljplanen, men bara om åtgärden är av tillfällig karaktär. Max 10 år, kan förlängas till 15 år totalt.",
    verified_source: { sfs: "2010:900", chapter: "9", paragraph: "33" },
    measurements: [
      { label: "Max tidsperiod", value: "10 år (förlängning upp till 15 år)" },
      { label: "Handläggningstid", value: "10 veckor (samma som vanligt bygglov)" },
      { label: "Avgift", value: "Vanligtvis lägre än permanent bygglov" },
    ],
    examples: [
      { type: "Företag", title: "Byggbodar under ombyggnad", text: "2 års tillfälligt bygglov – ansökan med tidsplan och återställningsplan." },
      { type: "Kommun", title: "Modulskola tillfälligt", text: "Vanligt för att avlasta permanent skola under 5-10 år." },
    ],
    mistakes: [
      "Att inte lämna in återställningsplan – kommunen kan neka utan den.",
      "Att låta byggnaden stå kvar efter perioden – blir olovligt bygge och sanktionsavgift.",
    ],
    municipality_variations: "Vissa kommuner (t.ex. Stockholm) har digitala tjänster särskilt för tidsbegränsade lov.",
    faq: [
      { q: "Kan ett tillfälligt bygglov bli permanent?", a: "Endast genom ny ansökan om permanent bygglov med planändring." },
    ],
    related: ["bygglov/handlaggningstid", "bygglov/olovligt-bygge"],
    updated: "2026-07-04",
  },
  {
    slug: "andrad-anvandning",
    title: "Bygglov för ändrad användning",
    h1: "Bygglov för ändrad användning – lokal till bostad",
    metaDescription: "Byte från lokal till bostad, eller garage till gäststuga, kräver bygglov för ändrad användning. Regler 2026.",
    keywords: "ändrad användning bygglov, lokal till bostad, garage till bostad",
    intro: "Att ändra användningen av en byggnad – t.ex. från kontor till bostad, eller garage till gästhus – kräver bygglov även om du inte ändrar utseendet. PBL 9 kap. 2 § p. 3.",
    verified_source: { sfs: "2010:900", chapter: "9", paragraph: "2" },
    measurements: [
      { label: "Bygglov krävs alltid", value: "Vid väsentligt ändrad användning" },
      { label: "BBR-krav", value: "Nya kraven för bostäder gäller (isolering, brand, ventilation)" },
      { label: "Handläggningstid", value: "10 veckor" },
    ],
    examples: [
      { type: "Villa", title: "Garage till gäststuga", text: "Bygglov krävs + BBR-anpassning (fönster, ventilation, brand)." },
      { type: "Företag", title: "Butik till kontor", text: "Bygglov krävs – prövning mot detaljplanens användning." },
    ],
    mistakes: [
      "Att tro att invändiga ändringar är fria – ändrad användning är alltid lovpliktig.",
      "Att glömma detaljplanens tillåtna användning – lokal kan vara låst till 'verksamhet'.",
    ],
    municipality_variations: "Bostadslägen i attraktiva områden får ofta lättare bygglov, medan verksamhetsmark är strängare.",
    faq: [
      { q: "Måste jag söka bygglov för att jobba hemifrån?", a: "Nej – hemarbete räknas inte som ändrad användning så länge det inte är kundmottagning eller skyltning." },
    ],
    related: ["bygglov/tillbyggnad", "bygglov/rivningslov", "detaljplan/vad-ar-en-detaljplan"],
    updated: "2026-07-04",
  },
  {
    slug: "solceller-detaljplan",
    title: "Solceller och detaljplan",
    h1: "Solceller i detaljplan – när krävs bygglov trots undantaget?",
    metaDescription: "Solceller är sedan 2018 bygglovsfria på villor, men i detaljplan med kulturmiljö-skydd krävs fortfarande bygglov. Regler 2026.",
    keywords: "solceller detaljplan, solceller kulturmiljö, bygglov solpanel",
    intro: "Sedan 2018 är solceller på tak till en- och tvåbostadshus bygglovsfria i normalfallet. MEN i detaljplaner med kulturmiljö- eller områdesskydd (Q, q, k) krävs fortfarande bygglov.",
    verified_source: { sfs: "2010:900", chapter: "9", paragraph: "3c" },
    measurements: [
      { label: "Bygglovsfritt", value: "Solceller följer takets lutning och form" },
      { label: "Bygglov krävs", value: "Kulturmiljöskydd, väsentligt ändrat utseende, kulturhus" },
      { label: "Anmälan", value: "Endast om ändring av bärande konstruktion" },
    ],
    examples: [
      { type: "Villa", title: "Solceller på ny villa", text: "Bygglovsfri – bara att montera enligt takets lutning." },
      { type: "Villa", title: "Q-märkt hus 1920", text: "Bygglov krävs – kulturmiljö skyddad i detaljplan." },
    ],
    mistakes: [
      "Att montera solceller på nockplan (utstickande från tak) utan bygglov.",
      "Att inte kolla detaljplanen – Q eller k-beteckning kräver alltid bygglov.",
    ],
    municipality_variations: "Stockholm, Göteborg och Malmö har extra strikta krav i innerstaden.",
    faq: [
      { q: "Krävs bygglov för solceller på attefallshus?", a: "Nej, samma undantag gäller." },
      { q: "Räknas markplacerade solceller som byggnader?", a: "Solcellsparker på mark kräver alltid bygglov." },
    ],
    related: ["bygglov/solceller", "detaljplan/vad-ar-en-detaljplan"],
    updated: "2026-07-04",
  },
  {
    slug: "kontrollansvarig",
    title: "Kontrollansvarig (KA) – när krävs det?",
    h1: "Kontrollansvarig – roll, kostnad och när det krävs",
    metaDescription: "Kontrollansvarig (KA) krävs vid större bygglov. Kostnad 15-40 000 kr. Ska vara certifierad enligt PBL 10 kap. 9 §.",
    keywords: "kontrollansvarig, KA bygglov, certifierad KA kostnad",
    intro: "Kontrollansvarig (KA) är en certifierad person som ska hjälpa dig att uppfylla kraven i PBL och BBR. Krävs vid större byggen men inte vid mindre åtgärder (attefall, mindre tillbyggnader).",
    verified_source: { sfs: "2010:900", chapter: "10", paragraph: "9" },
    measurements: [
      { label: "Krävs för", value: "Nybyggnad, större tillbyggnad, ändrad användning" },
      { label: "Krävs INTE för", value: "Attefall, friggebod, mindre altan, staket" },
      { label: "Kostnad", value: "15 000 – 40 000 kr beroende på projekt" },
      { label: "Certifiering", value: "Behörighet K (kvalificerad) eller N (normal)" },
    ],
    examples: [
      { type: "Villa", title: "Nybyggnad villa", text: "K-behörig KA krävs – kolla certifiering på boverket.se." },
      { type: "Villa", title: "Attefallshus 30 m²", text: "Ingen KA krävs – anmälan räcker." },
    ],
    mistakes: [
      "Att välja billigaste KA utan att kolla certifiering – kan leda till slutbesked-problem.",
      "Att kombinera KA med byggfirma från samma bolag – jäv, KA måste vara oberoende.",
    ],
    municipality_variations: "Ingen skillnad – KA-kravet gäller nationellt.",
    faq: [
      { q: "Kan jag vara egen KA?", a: "Endast om du själv är certifierad – annars måste extern KA anlitas." },
      { q: "Hur hittar jag certifierad KA?", a: "Sök på boverket.se/certifiering – där listas alla behöriga." },
    ],
    related: ["bygglov/handlaggningstid", "pbl/10-kap-kontrollplan-slutbesked"],
    updated: "2026-07-04",
  },
  {
    slug: "startbesked-slutbesked",
    title: "Startbesked och slutbesked",
    h1: "Startbesked och slutbesked – hur får man dem?",
    metaDescription: "Startbesked krävs innan du får börja bygga. Slutbesked innan du får flytta in. Krav, tidslinje och checklista.",
    keywords: "startbesked, slutbesked bygglov, tekniskt samråd",
    intro: "Bygglov är bara första steget. För att få börja bygga krävs startbesked (efter tekniskt samråd om KA finns) och för att få använda byggnaden krävs slutbesked (efter slutsamråd och slutkontroll).",
    verified_source: { sfs: "2010:900", chapter: "10", paragraph: "34" },
    measurements: [
      { label: "Startbesked", value: "Krävs INNAN byggstart" },
      { label: "Slutbesked", value: "Krävs INNAN inflytt/användning" },
      { label: "Bötesbelopp vid brott", value: "Sanktionsavgift enligt PBL 11 kap." },
      { label: "Handläggning", value: "2-4 veckor efter tekniskt samråd" },
    ],
    examples: [
      { type: "Villa", title: "Nybyggnad", text: "Bygglov → tekniskt samråd → startbesked → bygge → slutsamråd → slutbesked → inflytt." },
      { type: "Villa", title: "Interimistiskt slutbesked", text: "Om småfel återstår kan tillfälligt slutbesked ges." },
    ],
    mistakes: [
      "Att börja bygga direkt efter bygglov utan startbesked – ger sanktionsavgift.",
      "Att flytta in innan slutbesked – förbjudet enligt PBL 10 kap. 4 §.",
    ],
    municipality_variations: "Handläggningstid varierar – vissa småkommuner har 1 vecka, storstäder 4 veckor.",
    faq: [
      { q: "Kan jag få startbesked samma dag som bygglov?", a: "Vid enkla ärenden utan KA – ja, men vanligtvis 2-4 veckor efter." },
      { q: "Vad kostar slutbesked?", a: "Vanligtvis inget extra – ingår i bygglovsavgiften." },
    ],
    related: ["bygglov/kontrollansvarig", "pbl/10-kap-kontrollplan-slutbesked"],
    updated: "2026-07-04",
  },
];
